import { useCallback } from 'react'
import { useDomainIntl } from 'domains/insights-portal/utils/domain/intl'

const formattedValue = (value: number | null, callback: () => string) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '-'
  }

  return callback()
}

export const useFormatValue = () => {
  const { formatNumber } = useDomainIntl()

  const formatYesNoValue = (value: string) => {
    if (value === 'Y') return 'Yes'
    else if (value === 'N') return 'No'
    else return ''
  }

  const formatDecimal = useCallback(
    (value: number | null, compact: boolean) =>
      formattedValue(value, () =>
        formatNumber(value, {
          maximumFractionDigits: 2,
          notation: compact ? 'compact' : 'standard',
        })
      ),
    [formatNumber]
  )
  const formatInteger = useCallback(
    (value: number | null, compact: boolean) =>
      formattedValue(value, () =>
        formatNumber(value, {
          maximumFractionDigits: compact && value >= 1e3 ? 2 : 0,
          notation: compact ? 'compact' : 'standard',
        })
      ),
    [formatNumber]
  )

  const formatCurrency = useCallback(
    (value: number | null, compact: boolean) =>
      formattedValue(value, () =>
        formatNumber(value, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 2,
          notation: compact ? 'compact' : 'standard',
        })
      ),
    [formatNumber]
  )

  const formatPercentage = useCallback(
    (value: number | null) =>
      formattedValue(value, () =>
        formatNumber(value, {
          style: 'percent',
          maximumFractionDigits: 2,
        })
      ),
    [formatNumber]
  )

  return { formatDecimal, formatInteger, formatCurrency, formatPercentage, formatYesNoValue }
}
